import type { Translations } from './en';
const appName = process.env.NEXT_PUBLIC_APP_NAME || 'MyApp';
const de: Translations = {
  common: {
    appName: appName,
    loading: 'Laden...',
    save: 'Speichern',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    back: 'Zurück',
    search: 'Suchen',
    noResults: 'Keine Ergebnisse gefunden',
    error: 'Ein Fehler ist aufgetreten',
    success: 'Erfolgreich',
  },
  header: {
    searchPlaceholder: 'Nachrichten, Themen, Hashtags suchen...',
    searchPlaceholderMobile: 'Suchen...',
    home: 'Startseite',
    hotgirl: 'Hotgirl',
    coser: 'Coser',
    model: 'Model',
    upload: 'Hochladen',
    notifications: 'Benachrichtigungen',
    login: 'Anmelden',
    register: 'Registrieren',
  },
  footer: {
    tagline: `Die beste Plattform zum Teilen von Coser-, Hotgirl- und Model-Fotos auf ${appName}.`,
    copyright: `© {year} ${appName}. Alle Rechte vorbehalten.`,
    sections: {
      explore: 'Entdecken',
      account: 'Konto',
      support: 'Support',
    },
    links: {
      home: 'Startseite',
      hotgirl: 'Hotgirl',
      coser: 'Coser',
      model: 'Model',
      aoDai: 'Ao Dai',
      login: 'Anmelden',
      register: 'Registrieren',
      upload: 'Foto hochladen',
      dashboard: 'Dashboard',
      terms: 'Nutzungsbedingungen',
      privacy: 'Datenschutzrichtlinie',
      report: 'Verstoß melden',
      contact: 'Kontakt',
    },
  },
  collections: {
    title: 'Sammlungen',
    createAlbum: 'Album erstellen',
    saved: 'Gespeichert',
    noSaved: 'Noch keine Fotos gespeichert',
    noSavedHint: 'Jetzt Fotos entdecken →',
    removedSave: 'Aus Gespeicherten entfernt',
    createModalTitle: 'Neues Album erstellen',
    albumNamePlaceholder: 'Albumname...',
    cancel: 'Abbrechen',
    create: 'Erstellen',
    albumCreated: 'Album erstellt',
  },
  home: {
    title: 'Entdecke',
    titleHighlight: 'Schönheit',
    titleSuffix: 'des Lebens',
    subtitle: 'Täglich aktualisierte Tausende von Coser-, Hotgirl- und Model-Fotos',
    sortNewest: 'Neueste',
    sortTrending: 'Trending',
    sortPopular: 'Beliebt',
    allCategories: 'Alle',
    noMorePosts: 'Sie haben alle Fotos gesehen',
  },
  auth: {
    login: {
      title: 'Anmelden um fortzufahren',
      continueWithGoogle: 'Mit Google fortfahren',
      orLoginWithEmail: 'oder mit E-Mail anmelden',
      email: 'E-Mail',
      password: 'Passwort',
      forgotPassword: 'Passwort vergessen?',
      submitButton: 'Anmelden',
      loading: 'Anmeldung läuft...',
      noAccount: 'Noch kein Konto?',
      registerLink: 'Jetzt registrieren',
      errorCredentials: 'Falsche E-Mail oder falsches Passwort',
      successLogin: 'Erfolgreich angemeldet!',
    },
    register: {
      title: 'Kostenloses Konto erstellen',
      displayName: 'Anzeigename',
      displayNamePlaceholder: 'Max Mustermann',
      email: 'E-Mail',
      password: 'Passwort',
      passwordPlaceholder: 'Mindestens 8 Zeichen',
      confirmPassword: 'Passwort bestätigen',
      submitButton: 'Registrieren',
      loading: 'Konto wird erstellt...',
      hasAccount: 'Bereits ein Konto?',
      loginLink: 'Anmelden',
      errorPasswordMismatch: 'Passwörter stimmen nicht überein',
      errorPasswordLength: 'Passwort muss mindestens 8 Zeichen lang sein',
      errorGeneric: 'Registrierung fehlgeschlagen',
      successRegister: 'Konto erfolgreich erstellt!',
      emailTaken: 'E-Mail wird bereits verwendet',
      serverError: 'Serverfehler, bitte später erneut versuchen',
    },
    forgotPassword: {
      title: 'Passwort vergessen',
      subtitle: 'Geben Sie Ihre E-Mail ein und wir senden einen Reset-Link',
      email: 'E-Mail',
      submitButton: 'Reset-Link senden',
      backToLogin: 'Zurück zur Anmeldung',
      sending: 'Wird gesendet...',
      emailSent: 'E-Mail gesendet!',
      checkEmail: 'Überprüfen Sie den Posteingang von {email} für den Passwort-Reset-Link.',
      instructions: 'Geben Sie Ihre E-Mail ein und wir senden einen Link zum Zurücksetzen des Passworts.',
    },
  },
  userMenu: {
    dashboard: 'Dashboard',
    collections: 'Sammlungen',
    settings: 'Einstellungen',
    logout: 'Abmelden',
  },
  settings: {
    title: 'Kontoeinstellungen',
    profile: {
      nav: 'Profil',
      title: 'Profilinformationen',
      displayName: 'Anzeigename',
      username: 'Benutzername',
      website: 'Webseite',
      bio: 'Bio',
      bioPlaceholder: 'Stellen Sie sich vor...',
      changeAvatar: 'Avatar ändern',
      avatarHint: 'JPG, PNG, WebP max. 5 MB',
      saveButton: 'Änderungen speichern',
      saving: 'Wird gespeichert...',
      savedSuccess: 'Änderungen gespeichert',
    },
    password: {
      nav: 'Passwort',
      title: 'Passwort ändern',
      fields: {
        currentPassword: 'Aktuelles Passwort',
        newPassword: 'Neues Passwort',
        confirm: 'Neues Passwort bestätigen',
      },
      errors: {
        confirm: 'Neue Passwörter stimmen nicht überein',
        minLength: 'Passwort muss mindestens 8 Zeichen lang sein',
      },
      success: 'Passwort erfolgreich geändert!',
      saving: 'Wird gespeichert...',
      submit: 'Passwort ändern',
    },
    notifications: {
      nav: 'Benachrichtigungen',
      title: 'Benachrichtigungseinstellungen',
      options: {
        likes: 'Wenn jemand Ihr Foto liked',
        comments: 'Wenn jemand kommentiert',
        replies: 'Wenn jemand auf Ihren Kommentar antwortet',
        follows: 'Wenn jemand Ihnen folgt',
        approved: 'Wenn der Beitrag genehmigt wird',
        email_digest: 'Wöchentliche E-Mail-Zusammenfassung',
        marketing: 'Werbe- und Veranstaltungsbenachrichtigungen',
      },
      saveSuccess: 'Benachrichtigungseinstellungen gespeichert',
      saving: 'Wird gespeichert...',
      saveButton: 'Einstellungen speichern',
    },
    security: {
      nav: 'Sicherheit',
      twoFactorAuth: 'Zwei-Faktor-Authentifizierung (2FA)',
      twoFactorAuthHint: 'Erhöhen Sie die Sicherheit mit einem Verifizierungscode aus der App',
      comingSoon: 'Demnächst',
      activeSessions: 'Aktive Sitzungen',
      currentBrowser: 'Aktueller Browser',
      lastLogin: 'Letzte Anmeldung',
      active: 'Aktiv',
      dangerZone: 'Gefahrenzone',
      deleteAccountHint: 'Das Löschen Ihres Kontos entfernt alle Ihre Daten dauerhaft.',
      deleteAccount: 'Konto löschen',
    },
  },
  post: {
    likes: '{count} Likes',
    views: '{count} Aufrufe',
    shares: '{count} Geteilt',
    comments: '{count} Kommentare',
    save: 'Speichern',
    saved: 'Gespeichert',
    share: 'Teilen',
    linkCopied: 'Link kopiert!',
    follow: 'Folgen',
    following: 'Gefolgt',
    relatedPosts: 'Ähnliche Beiträge',
    commentPlaceholder: 'Kommentar schreiben...',
    commentLoginPlaceholder: 'Anmelden zum Kommentieren...',
    commentSubmit: 'Senden',
    commentSubmitting: 'Wird gesendet...',
    noComments: 'Noch keine Kommentare. Seien Sie der Erste!',
    savedToCollection: 'In Sammlung gespeichert',
    removedFromCollection: 'Aus Sammlung entfernt',
    description: 'Beschreibung',
    profileView: 'Profil ansehen',
    replies: 'Antworten',
    unsaved: 'Aus Gespeichertem entfernt',
    liked: 'Gefällt dir',
    like: 'Gefällt mir',
  },
  notifications: {
    title: 'Benachrichtigungen',
    empty: 'Keine Benachrichtigungen',
    markAllRead: 'Alle als gelesen markieren',
    types: {
      like_post: 'hat Ihr Foto geliked',
      comment: 'hat Ihr Foto kommentiert',
      reply: 'hat auf Ihren Kommentar geantwortet',
      follow: 'folgt Ihnen',
      approve: 'Ihr Beitrag wurde genehmigt',
      reject: 'Ihr Beitrag wurde abgelehnt',
      system: 'Systembenachrichtigung',
    },
  },
  search: {
    title: 'Suchergebnisse für',
    result: 'Ergebnisse',
    tryOtherKeywords: 'Andere Suchbegriffe versuchen...',
    noResults: 'Keine Ergebnisse für',
    placeholder: 'Suchen...',
    thisHashtag: 'Fotos mit diesem Hashtag',
    results: 'Ergebnisse',
  },
  upload: {
    title: 'Foto hochladen',
    dragDrop: 'Drag & Drop oder klicken zum Auswählen',
    supportedFormats: 'Unterstützt JPG, PNG, WebP, GIF',
    submit: 'Veröffentlichen',
    submitting: 'Wird veröffentlicht...',
    titleField: 'Titel',
    cover: 'Titelbild',
    titlePlaceholder: 'Einen ansprechenden Titel eingeben...',
    descriptionField: 'Beschreibung',
    descriptionPlaceholder: 'Detaillierte Beschreibung des Foto-Sets...',
    hashtagsField: 'Hashtags',
    statusField: 'Status',
    statusPublic: 'Öffentlich',
    statusPrivate: 'Privat',
    statusDraft: 'Entwurf',
    error: 'Fehler beim Hochladen',
    errorSelect: 'Mindestens 1 Foto auswählen',
    errorTitle: 'Titel eingeben',
    photos: 'Fotos',
    uploading: 'Wird hochgeladen...',
  },
  notFound: {
    title: 'Seite nicht gefunden',
    subtitle: 'Die gesuchte Seite existiert nicht.',
    backHome: 'Zurück zur Startseite',
  },
  liked: {
    title: 'Gelikte Beiträge',
    empty: 'Sie haben noch keine Beiträge geliket.',
  },
  user: {
    unknown: 'Unbekannt',
  },
  globalError: {
    title: 'Ein Fehler ist aufgetreten',
    subtitle: 'Entschuldigung für die Unannehmlichkeiten. Bitte versuchen Sie es erneut.',
    retry: 'Erneut versuchen',
  },
  username: {
    posts: 'Beiträge',
    likes: 'Likes',
    followers: 'Follower',
    following: 'Folge ich',
    editProfile: 'Profil bearbeiten',
    message: 'Nachricht',
    noPosts: 'Noch keine Beiträge.',
    bio: 'Fotos ansehen von ',
    notFound: 'Benutzer nicht gefunden',
  },
  topic: {
    notFound: 'Thema nicht gefunden',
    viewTitle: 'Thema ansehen ',
  },
  dashboard: {
    title: 'Dashboard',
    welcome: 'Hallo',
    stats: {
      posts: 'Beiträge',
      views: 'Aufrufe',
      likes: 'Likes',
      comments: 'Kommentare',
    },
  },
  adsblock: {
    title: 'Sie verwenden AdBlock',
    description: 'Bitte deaktivieren Sie AdBlock, um hochwertige Bilder anzuzeigen und uns zu helfen, die Website kostenlos zu halten.',
    action: 'Ich habe es deaktiviert — Neu laden',
    cancel: 'Überspringen',
  },
  pwa: {
    title: `Installieren Sie ${appName} für ein besseres Erlebnis!`,
    iosSubtitle: 'Drücken Sie Teilen → Zum Home-Bildschirm hinzufügen',
    androidSubtitle: 'Erhalten Sie Benachrichtigungen über neue Fotosets, sobald sie veröffentlicht werden',
    installButton: 'Installieren',
    disclaimer: 'Schnelle Installation, kein App Store erforderlich.',
  },
  autotrans: {
    title: 'Automatisch übersetzt',
    translated: 'Übersetzung',
    origin: 'Ursprünglicher Inhalt',
  },
  subscription: {
    title: 'Benachrichtigungen abonnieren',
    description: 'Erhalten Sie Benachrichtigungen über neue Fotosets, sobald sie veröffentlicht werden.',
    subscribeButton: 'Abonnieren',
    unsubscribeButton: 'Abonnement kündigen',
    subscribed: 'Sie sind für Benachrichtigungen angemeldet.',
    unsubscribed: 'Sie haben das Abonnement für Benachrichtigungen gekündigt.',
    error: 'Beim Aktualisieren Ihres Abonnements ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    success_tit: '🎉 Benachrichtigungen aktiviert!',
    denied_tit: 'Benachrichtigungen abgelehnt',
    error_tit: 'Ein Fehler ist aufgetreten',
    success_des: 'Sie erhalten Benachrichtigungen, wenn neuer Inhalt verfügbar ist.',
    denied_des: 'Sie können sie in den Einstellungen Ihres Browsers erneut aktivieren.',
    error_des: 'Bitte versuchen Sie es später erneut.',
    skip: 'Überspringen',
    processing: 'Wird verarbeitet...',
    noti: 'Benachrichtigungen aktivieren',
    rule: 'Nur Benachrichtigungen für neue Inhalte anzeigen.',
    notify_title: `Benachrichtigungen - ${appName}`,
    notify_body: "Die neue Galerie wurde veröffentlicht. Schau sie dir jetzt an!",
  },
  contact: {
    title: 'Kontaktieren Sie uns',
    subtitle: 'Wir würden uns freuen, von Ihnen zu hören! Bitte füllen Sie das folgende Formular aus und wir werden uns so schnell wie möglich bei Ihnen melden.',
    name: 'Name',
    email: 'E-Mail',
    subject: 'Betreff',
    message: 'Nachricht',
    submitButton: 'Nachricht senden',
    sending: 'Wird gesendet...',
    successTitle: 'Nachricht gesendet!',
    successMessage: 'Vielen Dank für Ihre Kontaktaufnahme. Wir werden uns in Kürze bei Ihnen melden.',
    errorTitle: 'Ein Fehler ist aufgetreten',
    errorMessage: 'Es gab einen Fehler beim Senden Ihrer Nachricht. Bitte versuchen Sie es später noch einmal.',
    res_time_title: 'Antwortzeit',
    res_time: 'Wir antworten normalerweise innerhalb von 1–3 Werktagen.',
    report_content: 'Inhalt melden',
    report_content_hint: 'Um einen Beitrag oder Benutzer zu melden, verwenden Sie die Schaltfläche "Melden" direkt im Inhalt oder wählen Sie oben "Inhalt melden".',
    value_default: 'Wählen Sie ein Thema',
    value_general: 'Allgemeine Anfrage',
    value_report: 'Inhalt melden',
    value_account: 'Konto Problem',
    value_business: 'Geschäft / Partnerschaft',
    value_feedback: 'Feedback & Vorschläge',
    value_other: 'Sonstiges'
  },
  language: {
    label: 'Sprache',
    en: 'English',
    vi: 'Tiếng Việt',
    zh: '中文',
    ja: '日本語',
    ko: '한국어',
    ar: 'العربية',
    fr: 'Français',
    es: 'Español',
    ru: 'Русский',
    hi: 'हिन्दी',
    id: 'Indonesia',
    de: 'Deutsch',
    pt: 'Português',
    it: 'Italiano',
  },
} as const;

export default de;